/*
 * @Author: Hong.Zhang
 * @Date: 2024-08-28 15:26:30
 * @Description:
 */
import { initRequestIdleCallbackPolyfill } from '@/utils/polyfill';
import {
  local,
  LOCAL_AB_TEST_VERSION,
  LOCAL_APPLICATION_FORM_DATA,
  LOCAL_TOKEN,
  productLevelLocal,
  session,
  SESSION_APPLICATION_ID,
  SESSION_INSURER,
  SESSION_IS_RENEWAL,
  SESSION_PLAN,
  SESSION_PRODUCT_NAME,
  SESSION_PRODUCT_TYPE,
  SESSION_REFERRAL_CODE,
  SESSION_USE_OCR,
} from '@/utils/storage';
import { decamelizeKeys } from 'humps';
import { parse } from 'qs';
import type { RequestConfig } from 'umi';
import { getLocale, history } from 'umi';

initRequestIdleCallbackPolyfill();

/**
 * Decamelize Request Params Keys
 * @param url
 * @param options
 */
const decamelizeParams = (url: string, options: any) => {
  const currentLang = getLocale() ?? globalThis.initLanguage;
  const { params, data, escapeDecamelize = false } = options;

  return {
    url,
    options: {
      ...options,
      params: escapeDecamelize
        ? { lang: currentLang, ...params }
        : {
            lang: currentLang,
            ...decamelizeKeys(params),
          },
      data: escapeDecamelize ? data : decamelizeKeys(data),
    },
  };
};

const addParamToHeader = (url: string, options: any) => {
  const { planKey } = session.getItem(SESSION_PLAN) ?? {};
  options.headers = {
    ...options.headers,
    'X-Axinan-Authorization': local.getItem(LOCAL_TOKEN),
    'X-Axinan-Plan-Key': planKey,
  };
  return { url, options };
};

export const request: RequestConfig = {
  prefix: API_URL,
  errorHandler: (error: any) => {
    throw error;
  },
  requestInterceptors: [addParamToHeader, decamelizeParams],
};

export const getInitialState = () => {
  const { search } = history.location;
  const queries = parse(search.substring(1)) as { [key: string]: string };
  const {
    locale,
    product: productType,
    'access-token': token,
    type: productName,
    insurer,
    application_id: applicationId,
    use_ocr: useOcr,
    isRenewal,
    referral_code: referralCode,
    version: abTestVersion,
  } = queries;
  if (!!applicationId) {
    session.setItem(SESSION_APPLICATION_ID, applicationId);
    session.setItem(SESSION_INSURER, insurer);
    session.setItem(SESSION_PRODUCT_NAME, productName);
    session.setItem(SESSION_IS_RENEWAL, isRenewal);
  }

  if (!!productName) {
    session.setItem(SESSION_PRODUCT_NAME, productName);
  }

  if (!!productType) {
    session.setItem(SESSION_PRODUCT_TYPE, productType);
  }

  if (locale) {
    session.setItem('locale', locale);
  }

  if (!!useOcr) {
    session.setItem(SESSION_USE_OCR, useOcr);
  }

  if (!!referralCode) {
    session.setItem(SESSION_REFERRAL_CODE, referralCode);
  }

  if (!!abTestVersion) {
    productLevelLocal.setItem(LOCAL_AB_TEST_VERSION, abTestVersion);
  }

  if (!!token || !!productType) {
    /**
     * Need to implement a proper API call to get complete the user profile flow
     */
    local.setItem(LOCAL_TOKEN, token);
    session.setItem(SESSION_PRODUCT_NAME, productName);
    session.setItem(SESSION_INSURER, insurer);
  }
  // if the insurer is not set in the session, set it from the application form data
  if (
    !session.getItem(SESSION_INSURER) &&
    productLevelLocal.getItem(LOCAL_APPLICATION_FORM_DATA)?.insurerName
  ) {
    session.setItem(
      SESSION_INSURER,
      productLevelLocal.getItem(LOCAL_APPLICATION_FORM_DATA)?.insurerName,
    );
  }
};
